<template>
  <div class="back" v-show="linkOk">
    <i class="iconfont icon-left" @click="back"></i>
    <!-- <div class="flex-1">golo课堂</div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      link: ''
    }
  },
  created() {
    this.link = localStorage.getItem('source_link')
  },
  computed: {
    linkOk() {
      return this.link && this.link.indexOf && this.link.indexOf('http') === 0
    }
  },
  methods: {
    back() {
      if (this.linkOk) {
        location.href = this.link
      }
    }
  }
}
</script>

<style scoped lang="stylus" ref="stylesheet/stylus">
  @import "~common/stylus/variable"
  .back
    padding: 0 size(20)
    background: #fff
    position: sticky
    top: 0
    left: 0
    z-index: 8
    display: flex
    align-items: center
    min-height: size(80)
    border-bottom: 1px solid #eee
  .flex-1
    flex: 1
    text-align: center
    font-size: size(28)
</style>


// WEBPACK FOOTER //
// src/components/base/ui/back.vue